import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {DomSanitizer, SafeStyle, SafeUrl, Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {LocalPbxService} from '../local-pbx.service';
import {CurrentUser} from '../../api/models/current-user';
import { HttpErrorResponse } from '@angular/common/http';
import { FlexModule } from '@angular/flex-layout';
import { MatButton, MatAnchor } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-pbx-user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatButton,
        MatTooltip,
        MatIcon,
        MatAnchor,
        NgIf,
        NgClass,
    ],
})
export class UserLoginComponent extends BaseComponent implements OnInit, OnDestroy {

  detailsUrl: string;
  gridHeight: SafeStyle;
  buttonSubmitPromise: Promise<void>;
  currentUser: CurrentUser;
  isLoading = false;
  hasError = false;
  errorMessage: string;
  showIframe = false;
  pbxUrl: SafeUrl;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              private sanitizer: DomSanitizer,
              public pbxService: LocalPbxService,
  ) {
    super(route, headerService, titleService, authService);

    this.detailsUrl = '../phone-number';

    this.editRoles = [RolesEnum.Fax_Edit, RolesEnum.Fax_Delete];
    this.deleteRoles = [RolesEnum.Fax_Delete];
  }

  ngOnInit() {
    this.currentUser = this.authService.currentUser.getValue();

    this.gridHeight = this.sanitizer.bypassSecurityTrustStyle('calc(100vh - 172px)');
    this.loginUserToPbx();

    console.log('on init');
    super.ngOnInit();
  }

  async loginUserToPbx() {
    this.isLoading = true;
    this.hasError = false;
    try {
      const sessionId = await this.pbxService.getUserSession();

      this.pbxUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://${this.currentUser.domain}/thirdparty.htm`);
      this.showIframe = true;

    } catch (e) {
      this.handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  handleError(err) {
    this.hasError = true;
    const generalMessage = 'Error occur while trying to login, try again later or check your settings';
    this.errorMessage = generalMessage;
    if (err instanceof HttpErrorResponse) {
      this.errorMessage = err.error.message || generalMessage;
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
